import type { FC } from 'react';
import { useCallback } from 'react';
import { useRouter } from '@application/utils';
import * as Styled from './styled';

export const ListingQuizzCta: FC = () => {
  const { translate, navigateToRoute } = useRouter();

  const onQuizClick = useCallback(() => {
    navigateToRoute('quiz', { state: {} });
  }, [navigateToRoute]);

  return (
    <Styled.ButtonContainer>
      <Styled.QuizWrapper>
        {translate('common.banners.quiz.title')}
        <Styled.ButtonWrapper color="blue" size="small" onClick={onQuizClick}>
          {translate('common.buttons.takeTest')}
        </Styled.ButtonWrapper>
      </Styled.QuizWrapper>
    </Styled.ButtonContainer>
  );
};
